export const SITE_SCHEMA_CONSTANTS = {
  NAME_ERROR_MESSAGE: 'Name should not be empty or more than 100 characters',
  DESCRIPTION_ERROR_MESSAGE: 'Description should not be empty or more than 100 characters'
};
